import React, { useState, useEffect } from "react";
import styles from "./style.module.css";
import Layout from "../../Components/Layout";
import { useForm } from "react-hook-form";
import { CiSquarePlus } from "react-icons/ci";
import { searchfilter } from "../../Services/APIrequests";
import { useNavigate } from "react-router-dom";
import { SuccessSwal, warningSwal } from "../../Util/Toast";
import {
    segments,
    revenueRanges,
    industry,
    creditRatings,
    dataStatuses,
    chargeMonths,
} from "../../pages/Mysearch/data";
import {
    getDistinctClassifications,
    getDistinctcorporatestatus,
    getDistinctlistingStatus,
    getDistinctCompanyIndustry,
    getDistinctCompanySegment,
} from "../../Services/APIrequests";
import { RotatingLines } from "react-loader-spinner";

function Mysearch({ onClose, inline = false, setAdvanceSearchOpen }) {
    const [searchResults, setSearchResults] = useState([]);
    const [classifications, setClassifications] = useState([]);
    const [companyStatus, setCompanyStatus] = useState([]);
    const [companyClass, setCompanyClass] = useState([]);
    const [companyIndustry, setCompanyIndustry] = useState([]);
    const [companySegment, setCompanySegment] = useState([]);
    const [errorMessage, setErrorMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState("company");

    const navigate = useNavigate();
    const { register, handleSubmit, reset } = useForm();

    useEffect(() => {
        const fetchClassifications = async () => {
            try {
                setLoading(true);
                const response = await getDistinctClassifications();
                setClassifications(response.data || []);
            } catch (error) {
                console.error("Error fetching classifications:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchClassifications();
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const [
                    statusResponse,
                    classResponse,
                    industryResponse,
                    segmentResponse,
                ] = await Promise.all([
                    getDistinctcorporatestatus(),
                    getDistinctlistingStatus(),
                    getDistinctCompanyIndustry(),
                    getDistinctCompanySegment(),
                ]);
                setCompanyStatus(statusResponse.data || []);
                setCompanyClass(classResponse.data || []);
                // Assuming the response data contains an array of objects like [{value, label}]
                setCompanyIndustry(industryResponse.data || []);
                setCompanySegment(segmentResponse.data || []);
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    const onSubmit = async (data) => {
        try {
            const requestBody = {
                approximateLocation: data.location?.trim() || null,
                nameContains: data.name?.trim() || null,

                incorporationDateRange: {
                    startDate: data.incorporationStartDate?.trim() || null,
                    endDate: data.incorporationEndDate?.trim() || null,
                },

                classification: data.classification?.trim() || null,
                // chargeCreationMonth: data.chargeCreation?.trim() || null,

                chargeCreationDateRange: {
                    startDate: data.chargeCreationStart?.trim() || null,
                    endDate: data.chargeCreationEnd?.trim() || null,
                },
                chargeHolder: data.chargeHolder?.trim() || null,
                sumOfChargesRange: data.sumOfCharges
                    ? JSON.parse(data.sumOfCharges)
                    : { min: null, max: null },
                corporateStatus: data.corporateStatus?.trim() || null,
                listingStatus: data.listingStatus?.trim() || null,
                industry: data.industry ? [data.industry.trim()] : [],
                segment: data.segments ? [data.segments.trim()] : [],
                revenueRange: data.revenue
                    ? JSON.parse(data.revenue)
                    : { min: null, max: null },
                creditRating: data.creditRatings?.trim() || null,
                pucRange: data.pucOoc
                    ? JSON.parse(data.pucOoc)
                    : { min: null, max: null },
            };

            navigate("/kohere/mysearch", { state: { requestBody } });
            // const response = await searchfilter(requestBody);
            setAdvanceSearchOpen(false);
            /*    if (response?.data?.data?.length) {
                setSearchResults(response.data.data);
                SuccessSwal("Companies found!", "The search was successful.");
            } else {
                setSearchResults([]);
                warningSwal(
                    "No companies found",
                    "Please try a different search term."
                );
            }

            setErrorMessage(""); */
        } catch (error) {
            const errorMessage =
                error.isAxiosError && error.response
                    ? error.response.data.message ||
                      "An unexpected error occurred"
                    : "An unexpected error occurred";

            setErrorMessage(errorMessage);
            warningSwal("Error", errorMessage);
            console.error("Error during search:", error);
        }
    };

    useEffect(() => {
        if (searchResults.length > 0) {
            window.scrollTo({
                top: 500,
                behavior: "smooth",
            });
        }
    }, [searchResults]);

    const handleRowClick = (cin) => {
        navigate(`/kohere/Companydetails/${cin}`);
    };

    return (
        <div>
            <>
                <div
                    className={`${styles.Mysearchcontainer} ${
                        inline ? styles.advancePopup : ""
                    }`}>
                    <div className={styles.sub_container}>
                        <div className={styles["form_container"]}>
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                    }}>
                                    <h2 className={styles.formheader}>
                                        Advance Filter
                                    </h2>
                                    {inline && (
                                        <button
                                            type="button"
                                            className={
                                                styles.advanceCloseButton
                                            }
                                            onClick={() =>
                                                onClose && onClose()
                                            }>
                                            ✕
                                        </button>
                                    )}
                                </div>

                                {/* Category Selection */}
                                <div className={styles.categoryTabs}>
                                    <button
                                        type="button"
                                        className={`${styles.categoryTab} ${
                                            selectedCategory === "company"
                                                ? styles.activeCategory
                                                : ""
                                        }`}
                                        onClick={() =>
                                            setSelectedCategory("company")
                                        }>
                                        Company Information
                                    </button>
                                    <button
                                        type="button"
                                        className={`${styles.categoryTab} ${
                                            selectedCategory === "business"
                                                ? styles.activeCategory
                                                : ""
                                        }`}
                                        onClick={() =>
                                            setSelectedCategory("business")
                                        }>
                                        Business Details
                                    </button>
                                    <button
                                        type="button"
                                        className={`${styles.categoryTab} ${
                                            selectedCategory === "financial"
                                                ? styles.activeCategory
                                                : ""
                                        }`}
                                        onClick={() =>
                                            setSelectedCategory("financial")
                                        }>
                                        Financial & Charges
                                    </button>
                                </div>

                                {/* Company Information Category */}
                                {selectedCategory === "company" && (
                                    <div
                                        className={styles.general_information_main}>
                                        <h2 className={styles.formsubheader}>
                                            Company Information
                                        </h2>
                                        <div
                                            className={
                                                styles.general_information
                                            }>
                                            <div
                                                className={styles["form-group"]}>
                                                <label htmlFor="location">
                                                    Approximate Location
                                                </label>
                                            <div
                                                className={
                                                    styles["formdivider_main"]
                                                }>
                                                <input
                                                    type="text"
                                                    id="location"
                                                    {...register("location")}
                                                    placeholder="Enter Street, City, State or Pincode"
                                                />
                                            </div>
                                        </div>
                                        <div className={styles["form-group"]}>
                                            <label htmlFor="name">
                                                Name Contains ?
                                            </label>
                                            <div
                                                className={
                                                    styles["formdivider_main"]
                                                }>
                                                <input
                                                    type="text"
                                                    id="name"
                                                    {...register("name")}
                                                    placeholder="Keywords that are part of corporate name, e.g. dairy, food, steel, chemical, etc."
                                                />
                                            </div>
                                        </div>
                                        <div className={styles["form-group"]}>
                                            <label htmlFor="incorporationDetails">
                                                Incorporation Year / Date / More
                                            </label>
                                            <div
                                                className={
                                                    styles["formdivider_main"]
                                                }>
                                                <div
                                                    className={
                                                        styles["form-inline"]
                                                    }>
                                                    {/* Start Date (Incorporation Date Start) */}
                                                    <input
                                                        type="date"
                                                        id="incorporationStartDate"
                                                        {...register(
                                                            "incorporationStartDate"
                                                        )}
                                                        placeholder="Start Date"
                                                    />
                                                    <span
                                                        className={
                                                            styles[
                                                                "text-center"
                                                            ]
                                                        }>
                                                        TO
                                                    </span>

                                                    {/* End Date (Incorporation Date End) */}
                                                    <input
                                                        type="date"
                                                        id="incorporationEndDate"
                                                        {...register(
                                                            "incorporationEndDate"
                                                        )}
                                                        placeholder="End Date"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        {/* Corporate Status */}
                                        <div className={styles["formdivider"]}>
                                            <div className={styles["form-group"]}>
                                                <label htmlFor="corporateStatus">
                                                    Corporate Status
                                                </label>
                                                <div
                                                    className={
                                                        styles[
                                                            "formdivider_main"
                                                        ]
                                                    }>
                                                    <select
                                                        id="corporateStatus"
                                                        {...register(
                                                            "corporateStatus"
                                                        )}>
                                                        <option
                                                            value=""
                                                            disabled
                                                            selected>
                                                            Select Corporate
                                                            Status
                                                        </option>
                                                        {loading ? (
                                                            <option disabled>
                                                                Loading...
                                                            </option>
                                                        ) : companyStatus.length >
                                                          0 ? (
                                                            companyStatus.map(
                                                                (
                                                                    option,
                                                                    index
                                                                ) => (
                                                                    <option
                                                                        key={
                                                                            index
                                                                        }
                                                                        value={
                                                                            option.Company_Status
                                                                        }>
                                                                        {
                                                                            option.Company_Status
                                                                        }
                                                                    </option>
                                                                )
                                                            )
                                                        ) : (
                                                            <option disabled>
                                                                No company
                                                                status available
                                                            </option>
                                                        )}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className={styles["form-group"]}>
                                                <label htmlFor="listingStatus">
                                                    Listing Status
                                                </label>
                                                <div
                                                    className={
                                                        styles[
                                                            "formdivider_main"
                                                        ]
                                                    }>
                                                    <select
                                                        id="listingStatus"
                                                        {...register(
                                                            "listingStatus"
                                                        )}>
                                                        <option
                                                            value=""
                                                            disabled
                                                            selected>
                                                            Listing Status
                                                        </option>
                                                        {loading ? (
                                                            <option disabled>
                                                                Loading...
                                                            </option>
                                                        ) : companyClass.length >
                                                          0 ? (
                                                            companyClass.map(
                                                                (
                                                                    option,
                                                                    index
                                                                ) => (
                                                                    <option
                                                                        key={
                                                                            index
                                                                        }
                                                                        value={
                                                                            option.Company_Class
                                                                        }>
                                                                        {
                                                                            option.Company_Class
                                                                        }
                                                                    </option>
                                                                )
                                                            )
                                                        ) : (
                                                            <option disabled>
                                                                No company class
                                                                available
                                                            </option>
                                                        )}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                )}

                                {/* Business Details Category */}
                                {selectedCategory === "business" && (
                                    <div
                                        className={styles.general_information_main}>
                                        <h2 className={styles.formsubheader}>
                                            Business Details
                                        </h2>
                                        <div
                                            className={
                                                styles.general_information
                                            }>
                                        <div className={styles["form-group"]}>
                                            <label htmlFor="classification">
                                                Classification
                                            </label>
                                            <div
                                                className={
                                                    styles["formdivider_main"]
                                                }>
                                                <select
                                                    id="classification"
                                                    {...register(
                                                        "classification"
                                                    )}>
                                                    <option
                                                        value=""
                                                        disabled
                                                        selected>
                                                        Select a classification
                                                    </option>
                                                    {loading ? (
                                                        <option disabled>
                                                            Loading...
                                                        </option>
                                                    ) : classifications.length >
                                                      0 ? (
                                                        classifications.map(
                                                            (option, index) => (
                                                                <option
                                                                    key={index}
                                                                    value={
                                                                        option.Sub_Category
                                                                    }>
                                                                    {
                                                                        option.Sub_Category
                                                                    }
                                                                </option>
                                                            )
                                                        )
                                                    ) : (
                                                        <option disabled>
                                                            No classifications
                                                            available
                                                        </option>
                                                    )}
                                                </select>
                                            </div>
                                        </div>
                                        <div className={styles["form-group"]}>
                                            <label htmlFor="industry">
                                                Industry
                                            </label>
                                            <div
                                                className={
                                                    styles["formdivider_main"]
                                                }>
                                                <select
                                                    id="industry"
                                                    {...register("industry")}>
                                                    <option
                                                        value=""
                                                        disabled
                                                        selected>
                                                        Select a Industry
                                                    </option>
                                                    {companyIndustry.map(
                                                        (option, index) => (
                                                            <option
                                                                key={index}
                                                                value={
                                                                    option.Industry
                                                                }>
                                                                {
                                                                    option.Industry
                                                                }
                                                            </option>
                                                        )
                                                    )}
                                                </select>
                                            </div>
                                        </div>
                                        <div className={styles["form-group"]}>
                                            <label htmlFor="segments">
                                                Segment(s)
                                            </label>
                                            <div
                                                className={
                                                    styles["formdivider_main"]
                                                }>
                                                <select
                                                    id="segments"
                                                    {...register("segments")}>
                                                    <option
                                                        value=""
                                                        disabled
                                                        selected>
                                                        Select a Segment(s)
                                                    </option>
                                                    {companySegment.map(
                                                        (option, index) => (
                                                            <option
                                                                key={index}
                                                                value={
                                                                    option.IndustrySubCategory
                                                                }>
                                                                {
                                                                    option.IndustrySubCategory
                                                                }
                                                            </option>
                                                        )
                                                    )}
                                                </select>
                                            </div>
                                        </div>
                                        <div className={styles["formdivider"]}>
                                            <div className={styles["form-group"]}>
                                                <label htmlFor="revenue">
                                                    Revenue ?
                                                </label>
                                                <div
                                                    className={
                                                        styles[
                                                            "formdivider_main"
                                                        ]
                                                    }>
                                                    <select
                                                        id="revenue"
                                                        {...register(
                                                            "revenue"
                                                        )}>
                                                        <option value="">
                                                            Select
                                                        </option>
                                                        {revenueRanges.map(
                                                            (range) => (
                                                                <option
                                                                    key={
                                                                        range.value
                                                                    }
                                                                    value={JSON.stringify(
                                                                        {
                                                                            min: range.min,
                                                                            max: range.max,
                                                                        }
                                                                    )}>
                                                                    {
                                                                        range.label
                                                                    }
                                                                </option>
                                                            )
                                                        )}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className={styles["form-group"]}>
                                                <label htmlFor="creditRatings">
                                                    Credit Ratings ?
                                                </label>
                                                <div
                                                    className={
                                                        styles[
                                                            "formdivider_main"
                                                        ]
                                                    }>
                                                    <select
                                                        id="creditRatings"
                                                        {...register(
                                                            "creditRatings"
                                                        )}>
                                                        <option value="">
                                                            Select
                                                        </option>
                                                        <option value="1">
                                                            Rated
                                                        </option>
                                                        <option value="0">
                                                            Not Rated
                                                        </option>
                                                        <option
                                                            value=""
                                                            disabled>
                                                            ------Ratings------
                                                        </option>
                                                        {creditRatings.map(
                                                            (rating) => (
                                                                <option
                                                                    key={
                                                                        rating.value
                                                                    }
                                                                    value={`{"rating":"${rating.value}"}`}>
                                                                    {
                                                                        rating.label
                                                                    }
                                                                </option>
                                                            )
                                                        )}
                                                        <option
                                                            value=""
                                                            disabled>
                                                            --------------------
                                                        </option>
                                                        <option value='{"rating":"D"}'>
                                                            D
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className={styles["form-group"]}>
                                                <label htmlFor="dataStatus">
                                                    Data Status
                                                </label>
                                                <div
                                                    className={
                                                        styles[
                                                            "formdivider_main"
                                                        ]
                                                    }>
                                                    <select
                                                        id="dataStatus"
                                                        {...register(
                                                            "dataStatus"
                                                        )}>
                                                        {dataStatuses.map(
                                                            (option) => (
                                                                <option
                                                                    key={
                                                                        option.value
                                                                    }
                                                                    value={
                                                                        option.value
                                                                    }>
                                                                    {
                                                                        option.label
                                                                    }
                                                                </option>
                                                            )
                                                        )}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                )}

                                {/* Financial & Charges Category */}
                                {selectedCategory === "financial" && (
                                    <div
                                        className={styles.general_information_main}>
                                        <h2 className={styles.formsubheader}>
                                            Financial & Charges
                                        </h2>
                                        <div
                                            className={
                                                styles.general_information
                                            }>
                                        <div className={styles["form-group"]}>
                                            <label htmlFor="pucOoc">
                                                PUC / OOC ?
                                            </label>
                                            <div
                                                className={
                                                    styles["formdivider_main"]
                                                }>
                                                <select
                                                    id="pucOoc"
                                                    {...register("pucOoc")}>
                                                    <option value="">
                                                        Select
                                                    </option>
                                                    <option value='{"from":100001,"to":500000}'>
                                                        1 to 5 lakhs
                                                    </option>
                                                    <option value='{"from":500001,"to":1500000}'>
                                                        5 to 15 lakhs
                                                    </option>
                                                    <option value='{"from":1500001,"to":5000000}'>
                                                        15 to 50 lakhs
                                                    </option>
                                                    <option value='{"from":5000001,"to":20000000}'>
                                                        50 to 200 lakhs
                                                    </option>
                                                    <option value="" disabled>
                                                        --------------------
                                                    </option>
                                                    <option value='{"from":20000001,"to":50000000}'>
                                                        2 to 5 crores
                                                    </option>
                                                    <option value='{"from":50000001,"to":100000000}'>
                                                        5 to 10 crores
                                                    </option>
                                                    <option value='{"from":100000001,"to":250000000}'>
                                                        10 to 25 crores
                                                    </option>
                                                    <option value="" disabled>
                                                        --------------------
                                                    </option>
                                                    <option value='{"to":100000}'>
                                                        Up to 1 lakh
                                                    </option>
                                                    <option value='{"to":500000}'>
                                                        Up to 5 lakhs
                                                    </option>
                                                    <option value='{"to":1500000}'>
                                                        Up to 15 lakhs
                                                    </option>
                                                    <option value='{"to":5000000}'>
                                                        Up to 50 lakhs
                                                    </option>
                                                    <option value='{"to":20000000}'>
                                                        Up to 200 lakhs
                                                    </option>
                                                    <option value="" disabled>
                                                        --------------------
                                                    </option>
                                                    <option value='{"to":50000000}'>
                                                        Up to 5 crores
                                                    </option>
                                                    <option value='{"to":100000000}'>
                                                        Up to 10 crores
                                                    </option>
                                                    <option value='{"to":250000000}'>
                                                        Up to 25 crores
                                                    </option>
                                                    <option value="" disabled>
                                                        --------------------
                                                    </option>
                                                    <option value='{"from":250000001}'>
                                                        More than 25 crores
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className={styles["form-group"]}>
                                            <label htmlFor="chargeCreation">
                                                Charge Creation / Latest
                                                Modification Month
                                            </label>
                                                <div
                                                    className={
                                                        styles[
                                                            "formdivider_main"
                                                        ]
                                                    }>
                                                    <div
                                                        className={
                                                            styles[
                                                                "form-inline"
                                                            ]
                                                        }>
                                                        <input
                                                            type="date"
                                                            id="chargeCreationStart"
                                                            {...register(
                                                                "chargeCreationStart"
                                                            )}
                                                            placeholder="Start Date"
                                                        />
                                                        <span
                                                            className={
                                                                styles[
                                                                    "text-center"
                                                                ]
                                                            }>
                                                            TO
                                                        </span>
                                                        <input
                                                            type="date"
                                                            id="chargeCreationEnd"
                                                            {...register(
                                                                "chargeCreationEnd"
                                                            )}
                                                            placeholder="End Date"
                                                        />
                                                    </div>
                                                </div>
                                        </div>
                                        <div className={styles["form-group"]}>
                                            <label htmlFor="chargeHolder">
                                                Charge Holder
                                            </label>
                                            <div
                                                className={
                                                    styles["formdivider_main"]
                                                }>
                                                <input
                                                    type="text"
                                                    id="chargeHolder"
                                                    {...register(
                                                        "chargeHolder"
                                                    )}
                                                    placeholder="Enter Charge Holder Name"
                                                />
                                            </div>
                                        </div>
                                        <div className={styles["form-group"]}>
                                            <label htmlFor="sumOfCharges">
                                                Sum Of Charges
                                            </label>
                                            <div
                                                className={
                                                    styles["formdivider_main"]
                                                }>
                                                <select
                                                    id="sumOfCharges"
                                                    {...register(
                                                        "sumOfCharges"
                                                    )}>
                                                    <option value="">
                                                        Select
                                                    </option>
                                                    <option value='{"to":0}'>
                                                        No Charge
                                                    </option>
                                                    <option
                                                        value=""
                                                        disabled>
                                                        --------------------
                                                    </option>
                                                    <option value='{"from":10000001,"to":25000000}'>
                                                        1 to 2.5 crores
                                                    </option>
                                                    <option value='{"from":25000001,"to":50000000}'>
                                                        2.5 to 5 crores
                                                    </option>
                                                    <option value='{"from":50000001,"to":100000000}'>
                                                        5 to 10 crores
                                                    </option>
                                                    <option value='{"from":100000001,"to":250000000}'>
                                                        10 to 25 crores
                                                    </option>
                                                    <option value='{"from":250000001,"to":1000000000}'>
                                                        25 to 100 crores
                                                    </option>
                                                    <option
                                                        value=""
                                                        disabled>
                                                        --------------------
                                                    </option>
                                                    <option value='{"from":1,"to":10000000}'>
                                                        Up to 1 crore
                                                    </option>
                                                    <option value='{"from":1,"to":25000000}'>
                                                        Up to 2.5 crores
                                                    </option>
                                                    <option value='{"from":1,"to":50000000}'>
                                                        Up to 5 crores
                                                    </option>
                                                    <option value='{"from":1,"to":100000000}'>
                                                        Up to 10 crores
                                                    </option>
                                                    <option value='{"from":1,"to":250000000}'>
                                                        Up to 25 crores
                                                    </option>
                                                    <option value='{"from":1,"to":1000000000}'>
                                                        Up to 100 crores
                                                    </option>
                                                    <option
                                                        value=""
                                                        disabled>
                                                        --------------------
                                                    </option>
                                                    <option value='{"from":1000000001}'>
                                                        More than 100 crores
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                )}

                                {/* Buttons Section */}
                                <div
                                    className={styles.general_information_main}>
                                    <div className={styles["form-buttons"]}>
                                        {/* <button
                                            type="button"
                                            className={styles["btn-reset"]}
                                            onClick={() => {
                                                reset();
                                                setSelectedCategory("company");
                                            }}>
                                            Reset Filters
                                        </button> */}
                                        <button
                                            type="button"
                                            className={styles["btn-clear"]}
                                            onClick={() => reset()}>
                                            Clear
                                        </button>
                                        <button
                                            type="submit"
                                            className={styles["btn-search"]}>
                                            Search
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                {/*    <div className={styles.Mysearchtable}>
                        <table className={styles.commantable}>
                            <thead className={styles.table_header}>
                                <tr className={styles.tableHeaderRow}>
                                    <th className={styles.tableHeader}>Name</th>
                                    <th className={styles.tableHeader}>
                                        Authorized Capital
                                    </th>
                                    <th className={styles.tableHeader}>
                                        Company Category
                                    </th>
                                    <th className={styles.tableHeader}>
                                        Address
                                    </th>
                                    <th className={styles.tableHeader}>
                                        Status
                                    </th>
                                    <th className={styles.tableHeader}>
                                        Principal Business Activity
                                    </th>
                                    <th className={styles.tableHeader}>
                                        State
                                    </th>
                                    <th className={styles.tableHeader}>
                                        Registrar
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td
                                            colSpan="8"
                                            style={{
                                                textAlign: "center",
                                                padding: "20px",
                                            }}>
                                            <RotatingLines
                                                height="50"
                                                width="50"
                                                strokeColor="#4fa94d"
                                                ariaLabel="loading"
                                                visible={true}
                                            />
                                        </td>
                                    </tr>
                                ) : Array.isArray(searchResults) &&
                                  searchResults.length > 0 ? (
                                    searchResults.map((result, index) => (
                                        <tr
                                            key={index}
                                            onClick={() =>
                                                handleRowClick(result.CIN)
                                            }>
                                            <td>{result.CompanyName}</td>
                                            <td>
                                                {Number(
                                                    result.Authorized_Capital
                                                ).toLocaleString("en-IN")}
                                            </td>
                                            <td>{result.Company_Category}</td>
                                            <td>
                                                {result.RegisteredOfficeAddress}
                                            </td>
                                            <td>{result.Company_Status}</td>
                                            <td>
                                                {
                                                    result.Principal_BusinessActivity
                                                }
                                            </td>
                                            <td>{result.Registered_State}</td>
                                            <td>
                                                {result.Registrar_Of_Companies}
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td
                                            colSpan="8"
                                            style={{ textAlign: "center" }}>
                                            No results found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div> */}
            </>
        </div>
    );
}

export default Mysearch;
